import React from 'react'
import styles from './styles/Navibar.module.css'
import { GetUrlAbout, GetUrlContact, GetUrlIndex, GetUrlNews, GetUrlWork } from './const'
import { useRouter } from './UseRouter'
import { Dropdown, Menu } from 'antd'

export default function Navibar(props) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const router = useRouter(props)
  const URL_INDEX = GetUrlIndex(router)
  const URL_WORK = GetUrlWork(router)
  const URL_NEWS = GetUrlNews(router)
  const URL_ABOUT = GetUrlAbout(router)
  const URL_CONTACT = GetUrlContact(router)

  const naviClass = (url) => {
    if (router.pathname && router.pathname.endsWith(url)) return `${styles.navilink} ${styles.navilinkUnderline}`
    else return `${styles.navilink}`
  }

  const naviClasses = (url) => {
    if (router.pathname && router.pathname.startsWith(url)) return `${styles.navilink} ${styles.navilinkUnderline}`
    else return `${styles.navilink}`
  }

  const getCollectionUrl = (id, title) => {
    return id + 1 + '_' + title.toLowerCase() + '/'
  }

  const getCollectionLayout = (props) => {
    let collections
    if (props.profile?.collections) {
      collections = props.profile.collections
    } else {
      collections = props.profileDetail?.collections
    }

    if (collections) {
      const ret = collections.map((item, index) => {
        return (
          <Menu.Item>
            <a
              key={item.title}
              style={{ minWidth: 128 }}
              onClick={() => {
                router.push(URL_WORK + getCollectionUrl(index, item.title))
              }}
            >
              {item.title}
            </a>{' '}
          </Menu.Item>
        )
      })
      return [
        <Menu.Item>
          <a
            key='all'
            style={{ minWidth: 128 }}
            onClick={() => {
              router.push(URL_WORK + 'all/')
            }}
          >
            {'All'}
          </a>{' '}
        </Menu.Item>
      ].concat(ret)
    }
  }

  const menu = <Menu>{getCollectionLayout(props)}</Menu>

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        paddingTop: 3,
        paddingLeft: 4,
        paddingRight: 4
      }}
    >
      <h1
        className={styles.navititle}
        onClick={async () => {
          await router.push(URL_INDEX)
        }}
      >
        {props.artistName}
      </h1>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '2', marginRight: 12 }}>
        <Dropdown overlay={menu} placement='bottomLeft'>
          <a style={{ display: 'block' }} className={naviClasses(URL_WORK)}>
            Works
          </a>
        </Dropdown>
        <a style={{ display: 'block' }} href={URL_NEWS} className={naviClass(URL_NEWS)}>
          News
        </a>
        <a style={{ display: 'block' }} href={URL_ABOUT} className={naviClass(URL_ABOUT)}>
          About
        </a>
        <a style={{ display: 'block' }} href={URL_CONTACT} className={naviClass(URL_CONTACT)}>
          Contact
        </a>
      </div>
    </div>
  )
}
